export default __webpack_public_path__ + "static/assets/1fc506fb59ba82fcff923ebe7525b882.png";